import { forwardRef } from 'react';

import { cn } from '@/shared/utils/cn/cn.util';

import { fieldVariants } from '../field/field.tokens';

import { type InputProps } from './Input.types';

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, inputSize, isInvalid = false, type, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      // An input with no `type` is a text input by spec, but writing it makes
      // the intent explicit and stops a stray `type` from being forgotten.
      type={type ?? 'text'}
      // `undefined`, never `"false"`: `aria-invalid="false"` is a valid value
      // that some screen readers still announce as a state change.
      aria-invalid={isInvalid ? true : undefined}
      className={cn(fieldVariants({ fieldSize: inputSize }), className)}
      {...props}
    />
  );
});
